"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const react_design_system_1 = require("@hdh-core/react-design-system");
const react_intl_1 = require("react-intl");
const transactionSigningApi_1 = require("../apis/transactionSigningApi");
const constants_1 = require("../constants");
const NoActiveSoftToken = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { showUserNoActiveSoftToken, logoutDetail } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const handleToggleCloseUserNoActiveSoftToken = (cancel) => {
        console.log('handleToggleCloseInvalid');
        dispatch((0, transactionSigningAction_1.toggleCloseUserNoActiveSoftToken)(cancel));
    };
    const intl = (0, react_intl_1.useIntl)();
    const clickOkButton = () => {
        if (constants_1.isR4) {
            window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.TAC_CANCEL }, constants_1.parentOrigin);
        }
        handleToggleCloseUserNoActiveSoftToken(true);
        dispatch((0, transactionSigningAction_1.setErrorMsg)(undefined));
        (0, transactionSigningApi_1.whenUserLogout)(logoutDetail);
    };
    return (react_1.default.createElement(react_design_system_1.AlertDialog, { isOpen: showUserNoActiveSoftToken, setOpen: handleToggleCloseUserNoActiveSoftToken, title: intl.formatMessage({ id: 'transaction-signing-hard-token-unable-to-proceed' }), message: intl.formatMessage({ id: 'transaction-signing-hard-token-not-activated' }), onClick: clickOkButton }));
};
exports.default = NoActiveSoftToken;
